import { VisitStatusEnum } from '@generated';
import { NavigatePreviousButton } from '../../shared/NavigatePreviousButton';
import { EndVisitButton } from './EndVisitButton';
import { useVisit } from '../../VisitContext';

export function VisitSummaryFooter() {
	const { visitStatusId } = useVisit();
	return (
		<>
			<div className="flex space-x-2">
				<NavigatePreviousButton />
			</div>
			{visitStatusId === VisitStatusEnum.InProgress && <EndVisitButton />}
		</>
	);
}
